import { useAppDispatch } from "@/app/hooks";
import { deleteSubscription } from "@/features";
import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type Props = {
  isOpen: boolean;
  selectedId: number;
  onSuccess: () => void;
  toggle: () => void;
};

export const DeleteSubscription = ({
  isOpen,
  selectedId,
  onSuccess,
  toggle,
}: Props) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onDelete = async () => {
    setIsSubmitting(true);
    try {
      await dispatch(deleteSubscription(selectedId)).unwrap();
      onSuccess();
      toggle();
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        <p>
          Are you sure want to <span className="fw-bold">DELETE</span> this
          subscription?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()} disabled={isSubmitting}>
          Close
        </Button>
        <Button
          color="danger"
          onClick={() => onDelete()}
          disabled={isSubmitting}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
